import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BaseService } from "./base.service";
import { BsInquiryCoverageMotorMappingService } from "./bsInquiryCoverageMotorMapping.service";
import { BsInquiryCoverageMotorMappingV2Service } from "./bsInquiryCoverageMotorMappingV2.service";
import { BsInquiryFactorConditionService } from "./bsInquiryFactorCondition.service";
import { BsInquiryInsuranceCoverageService } from "./bsInquiryInsuranceCoverage.service";
import { BsInquiryInsuranceInfoService } from "./bsInquiryInsuranceInfo.service";
import { BsInquiryInsurancePremiumService } from "./bsInquiryInsurancePremium.service";
import { BsInquiryPromotionInfoService } from "./bsInquiryPromotionInfo.service";
import { BsInquiryRecommendProductService } from "./bsInquiryRecommendProduct.service";
import { BsInquirySecurityContentService } from "./bsInquirySecurityContent.service";
import { BsInquirySecurityGroupContentService } from "./bsInquirySecurityGroupContent.service";
import { BsInquirySecuritySubTypeContentService } from "./bsInquirySecuritySubTypeContent.service";
import { InquiryInsurancePromotionConditionService } from "./inquiryInsurancePromotionCondition.service";
import { CheckblacklistService } from "./checkblacklist.service";
import { DeleteOTPService } from "./deleteOTP.service";
import { GenerateOTPService } from "./generateOTP.service";
import { GetAllBuildingTypeService } from "./getAllBuildingType.service";
import { GetAllPropertyTypeService } from "./getAllPropertyType.service";
import { GetAllSecuritiesGroupAndSecuritiesSubTypeService } from "./getAllSecuritiesGroupAndSecuritiesSubType.service";
import { GetDiscountInfoService } from "./getDiscountInfo.service";
import { GetInsuranceInfoService } from "./getInsuranceInfo.service";
import { GetOnlineSecurityGroupandSecuritySubTypeService } from "./getOnlineSecurityGroupandSecuritySubType.service";
import { GetReference2Service } from "./getReference2.service";
import { LeadsRegistrationService } from "./leadsRegistration.service";
import { VerifyOTPService } from "./verifyOTP.service";
import { DocumentDownloadService } from "./documentDownload.service";
import { GetAllInsuranceRelationshipService } from "./getAllInsuranceRelationship.service";
import { GetTitleNameService } from "./getTitleName.service";
import { GetAllInsuranceNationalityService } from "./getAllInsuranceNationality.service";
import { GetCountryService } from "./getCountry.service";
import { GetMaritalStatusService } from "./getMaritalStatus.service";
import { GetAllInsuranceOccupationService } from "./getAllInsuranceOccupation.service";
import { GetAllInsuranceSubOccupationService } from "./getAllInsuranceSubOccupation.service";
import { GetAllInsuranceLocationService } from "./getAllInsuranceLocation.service";
import { GetAllLocationService } from "./getAllLocation.service";
import { GenInsuranceTransactionNumberService } from "./genInsuranceTransactionNumber.service";
import { GetIdentityService } from "./getIdentity.service";
import { InsuranceNotifyService } from './insuranceNotify.service';
import { BsTransactionInsurerBKIValidatenService } from './bsTransactionInsurerBKIValidate.service';
import { GenVoucherNumberService } from './genVoucherNumber.service';
import { CreateCustomerAccountService } from './createCustomerAccount.service';
import { GetInsuranceRenewMotorService } from './getInsuranceRenewMotor.service';
import { GetCompanyUCIDService } from './getCompanyUCID.service';
import { UpdatePaymentDetailService } from './updatePaymentDetail.service';
import { SendLineMessageService } from './sendLineMessage.service';
import { CreatePaymentDetailService } from './createPaymentDetail.service';
import { CreateOrderTransactiontService } from './createOrderTransaction.service';
import { PlaceOrderService } from './placeOrder.service';
import { StartPaymentService } from './startPayment.service';
import { GetPaymentTokenService } from './getPaymentToken.service';
import { EntryTransactionPaymentService } from './entryTransactionPayment.service';
import { GetContractReasonService } from './getContractReason.service';
import { GetInsuranceCompanyBySecurityIDService } from './getInsuranceCompanyBySecurityID.service';
import { QrFormatService } from './qrFormat';
import { BsTransactionInsurerBKIConfirmService } from './bsTransactionInsurerBKIConfirm.service';
import { SendEmailService } from './sendEmail.service';
import { EventService } from './event.service';
import { GetAllProductService } from './getAllProduct.service';
import { GetRenewalDetailService } from './getRenewalDetail.service';
import { GetRenewalNonmotorDetailService } from './getRenewalNonmotorDetail.service';
import { GetRenewalCompareService } from './getRenewalCompare.service';
import { GetCheckHolidayDealerService} from './getCheckHolidayDealer.service';
import { CheckblacklistValidateBKIService } from './checkblacklistValidateBKI.service';
import { RecaptchaVerifyService } from './recaptchaVerify.service';
import { CheckVerifyService } from './checkVerify.service';
import { CheckPaymentService } from './checkPayment.service';
import { BsInquiryInsurancePremiumRangeService } from './bs-inquiry-insurance-premium-range.service';
import { getProductDetailService } from './getProductDetail.service';
import { BuyInsuranceService } from './buyInsurance.service';
import { AppInfoService } from './app-info.service';
import { checkIsLineUsernameExist } from './checkIsLineUsernameExist.service';
import { checkUserIsExistByIdAndPhone } from './checkUserIsExistByIdAndPhone.service';
import { BsCommonGetTokenUrlService } from './bsCommonGetTokenUrl.service';
import { MotorGetToken } from './motorGetToken';
import { BlogService } from './blog.service';
import { CacheService } from './cache.service';
import { getShortUrlVariableService } from './getShortUrlVariable.service';
import { ConsentUrlService } from './consentUrl.service';
import { TestService } from "./test.service";
import { TermsService } from "./terms.service";
import { GetNissanInsureProductService } from "./getNissanInsureProduct.service";
import { GetLandingPopupService } from "./getLandingPopup.service";
import { RenewCreateAccount } from "./renewCreateAccount";
import { GetInsuranceRenewQRPayment } from './getInsuranceRenewQRPayment.service';
import { UpdateCustomerPaymentQRSercice } from './updateCustomerPaymentQR.service';
import { GetQrBarcodePayment } from './getQrBarcodePayment.service';
import { UpdateRenewDetailService } from './updateRenewDetail.service';
import { UpdateRenewNonmotorDetailService } from './updateRenewNonmotorDetail.service';
import { GetWrapUpQrPayment } from './getWrapUpQrPayment.service';
import { CallTss } from './callTss.service';
import { CallNotify } from './callNotify.service';
import { CalculateInstallment } from './calculateInstallment.service';
import { UpdateRenewLetterInstallment } from './updateRenewLetterInstallment.service';
import { UpdateRenewNonmotorLetterInstallment } from './updateRenewNonmotorLetterInstallment.service';
import { GetMotorPaymentSummary } from './getMotorPaymentSummary.service';
import { CalculateInstallmentNonmotor } from './calculateInstallmentNonmotor.service';
import { GetNonMotorPaymentSummary } from './getNonMotorPaymentSummary.service';
import { updateRenewNonMotorOmiseService } from './updateRenewNonMotorOmise.service';
import { updateF09StatusService } from './updateF09Status.service';
import { CheckWrapUpNonMotorService } from './checkWrapUpNonMotor.service';
import { DataSharedService} from './dataShared.service'
import { ConvertTimestamp } from './convertTimestamp.service';
import { SendLineAddTagsService } from './sendLineAddTags.service'
import { GetLocationAllService } from "./getLocationAll.service";
import { GetTextFormConfirm } from './getTextFormConfirm.service'
import { GetTextThankyou } from "./getTextThankyou.service";
import { GetLineTokenService } from "./getLineToken.service";
import { SelfPaymentService } from "./selfPayment.service";
import { GetWorkingDayWebchatService } from "./getWorkingDayWebchat.service";
// import  /** Don't Delete, Pointer for auto generate */

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    BaseService,
    BsInquiryCoverageMotorMappingService,
    BsInquiryCoverageMotorMappingV2Service,
    BsInquiryFactorConditionService,
    BsInquiryInsuranceCoverageService,
    BsInquiryInsuranceInfoService,
    BsInquiryInsurancePremiumService,
    BsInquiryPromotionInfoService,
    BsInquiryRecommendProductService,
    BsInquirySecurityContentService,
    BsInquirySecurityGroupContentService,
    BsInquirySecuritySubTypeContentService,
    BsTransactionInsurerBKIConfirmService,
    InquiryInsurancePromotionConditionService,
    CheckblacklistService,
    DeleteOTPService,
    GenerateOTPService,
    GetAllBuildingTypeService,
    GetAllPropertyTypeService,
    GetRenewalDetailService,
    GetRenewalNonmotorDetailService,
    GetRenewalCompareService,
    GetAllSecuritiesGroupAndSecuritiesSubTypeService,
    GetDiscountInfoService,
    GetInsuranceInfoService,
    GetOnlineSecurityGroupandSecuritySubTypeService,
    GetReference2Service,
    LeadsRegistrationService,
    VerifyOTPService,
    DocumentDownloadService,
    GetAllInsuranceRelationshipService,
    GetTitleNameService,
    GetAllInsuranceNationalityService,
    GetCountryService,
    GetMaritalStatusService,
    GetAllInsuranceOccupationService,
    GetAllInsuranceSubOccupationService,
    GetAllInsuranceLocationService,
    GetAllLocationService,
    GenInsuranceTransactionNumberService,
    GetIdentityService,
    InsuranceNotifyService,
    BsTransactionInsurerBKIValidatenService,
    GenVoucherNumberService,
    CreateCustomerAccountService,
    UpdatePaymentDetailService,
    SendLineMessageService,
    GetInsuranceRenewMotorService,
    GetCompanyUCIDService,
    CreatePaymentDetailService,
    CreateOrderTransactiontService,
    PlaceOrderService,
    StartPaymentService,
    GetPaymentTokenService,
    EntryTransactionPaymentService,
    QrFormatService,
    MotorGetToken,
    GetContractReasonService,
    GetInsuranceCompanyBySecurityIDService,
    SendEmailService,
    EventService,
    GetAllProductService,
    GetCheckHolidayDealerService,
    CheckblacklistValidateBKIService,
    RecaptchaVerifyService,
    CheckVerifyService,
    CheckPaymentService,    
    BsInquiryInsurancePremiumRangeService,
    getProductDetailService,
    BuyInsuranceService,
    AppInfoService,
    checkIsLineUsernameExist,
    checkUserIsExistByIdAndPhone,
    BsCommonGetTokenUrlService,
    BlogService,
    CacheService,
    getShortUrlVariableService,
    ConsentUrlService,
    TestService,
    TermsService,
    GetLandingPopupService,
    RenewCreateAccount,
    GetInsuranceRenewQRPayment,
    UpdateCustomerPaymentQRSercice,
    GetQrBarcodePayment,
    UpdateRenewDetailService,
    UpdateRenewNonmotorDetailService,
    GetWrapUpQrPayment,
    CallTss,
    CallNotify,
    GetNissanInsureProductService,
    CalculateInstallment,
    CalculateInstallmentNonmotor,
    UpdateRenewLetterInstallment,
    UpdateRenewNonmotorLetterInstallment,
    GetMotorPaymentSummary,
    GetNonMotorPaymentSummary,
    updateRenewNonMotorOmiseService,
    updateF09StatusService,
    CheckWrapUpNonMotorService,
    DataSharedService,
    ConvertTimestamp,
    SendLineAddTagsService,
    GetLocationAllService,
    GetTextFormConfirm,
    GetTextThankyou,
    GetLineTokenService,
    SelfPaymentService,
    GetWorkingDayWebchatService
    // service  /** Don't Delete, Pointer for auto generate */
  ],
  exports: [],
})
export class AdaptersModule { }
